export const meta = { id: 'O11', slug: 'metodologia-no-diagnostico', title: 'Como a Metodologia alimenta o Diagnóstico', description: 'Entenda como Competências, Níveis e Descritores formam a base do Diagnóstico.', profile: 'owner', category: 'metodologia', type: 'flow', status: 'published', order: 410, keywords: ['metodologia','diagnóstico','competência','níveis','descritores'], previous: 'O10', next: 'O12', related: ['O06','A02'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como a Metodologia alimenta o Diagnóstico

A lógica da estrutura é direta:

**Competência → Níveis → Descritores → Diagnóstico → Desenvolvimento**

O Diagnóstico utiliza essa base para oferecer uma referência estruturada sobre o momento atual do Aluno.

<Callout type="warning">Alterações na metodologia podem afetar a forma como novos diagnósticos e acompanhamentos são interpretados. Faça mudanças com critério metodológico.</Callout>

<Callout type="important">A geração automática por IA de competências, níveis ou descritores não faz parte da versão atual documentada.</Callout>
